import { combineActions, handleActions } from 'redux-actions'

import * as healthActions from '@tabeeb/modules/healthData/actions'

const defaultState = []

export default handleActions(
  {
    [healthActions.addPatientHealthDataChart](state, { payload }) {
      return [...state, { ...payload, convertedData: [] }]
    },
    [healthActions.removePatientHealthDataChart](state, { payload }) {
      return state.filter((chartHealthData) => chartHealthData.dataType !== payload.dataType)
    },
    [healthActions.setPatientChartInterval](state, { payload }) {
      return state.map((chartHealthData) => {
        if (chartHealthData.dataType !== payload.dataType) {
          return chartHealthData
        }
        return { ...chartHealthData, interval: payload.interval }
      })
    },
    [healthActions.setPatientChartsBySetting](state, { payload }) {
      return payload
    },
    [healthActions.setGraphCoordinatesOfViewedPatient](state, { payload: graphCoordinates }) {
      return state.map((chartHealthData) => ({
        ...chartHealthData,
        convertedData: graphCoordinates[chartHealthData.dataType],
      }))
    },
    [combineActions(healthActions.resetHealthChartsStateOfViewedPatient, healthActions.resetViewedPatientState)]() {
      return defaultState
    },
  },
  defaultState
)
